import { gql } from '@apollo/client'
import { ID, IQueryBasicDataWithParameters } from '../IQueryData'

export interface IAssignUserToParkingPoolData {
  assignUserToParkingPool: IQueryBasicDataWithParameters
}

export interface IAssignUserToParkingPoolVars {
  pool: ID
  login: string
}

export const ASSIGN_USER_TO_PARKING_POOL = gql`
  mutation assignUserToParkingPool($pool: ID!, $login: String!) {
    assignUserToParkingPool(pool: $pool, login: $login) {
      status
      code
      message
      error
      parameters {
        name
        value
      }
    }
  }
`
